import { useState, useCallback } from 'react'
import { FilterService } from '../../../services'

const useFilterVariableValues = collectId => {
  const [variableValues, setVariableValues] = useState({})

  const loadVariableValues = useCallback(variableId => {
    if (variableValues[variableId] || !variableId || !collectId)
      return


    FilterService.getVariableValues(collectId, variableId)
      .then(response => {
        setVariableValues(prev => ({
          ...prev,
          [variableId]: response.values.map(value => {
            const content = typeof value === 'string' ? value : value.content
            return { value: content, label: content }
          })
        }))
      })
      .catch(() => {
        setVariableValues(prev => ({
          ...prev,
          [variableId]: []
        }))
      })
  }, [collectId, variableValues])

  return {
    variableValues,
    loadVariableValues
  }
}

export default useFilterVariableValues